"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
function FilterMenu(props) {
  var cat = props.cat,
    updateCat = props.updateCat;
  var categories = reconnect_js_1.useOutlet(props.categories)[0];
  var _a = react_1.useState([]),
    openKeys = _a[0],
    setOpenKeys = _a[1];
  react_1.useEffect(function () {
    var _a;
    if (!cat) {
      return;
    }
    var _nestedCategory = categories.filter(function (c) {
      var _a;
      return (((_a = c.items) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
    });
    var defaultOpenKeys = (_a = _nestedCategory.find(function (c) {
      var _a;
      return !!((_a = c.items) === null || _a === void 0 ? void 0 : _a.find(function (i) {
        return i.name === cat;
      }));
    })) === null || _a === void 0 ? void 0 : _a.name;
    setOpenKeys(defaultOpenKeys ? [defaultOpenKeys + "-sub"] : []);
  }, [cat, categories]);
  var onMenuClick = function onMenuClick(cat) {
    return function () {
      var pub = typeof cat.public === 'undefined' ? true : cat.public;
      if (!pub) {
        antd_1.message.warn('尚未開放，敬請期待');
        return;
      }
      updateCat(cat.name);
    };
  };
  return react_1.default.createElement(antd_1.Menu, {
    style: {
      width: 256,
      position: 'sticky',
      top: 84
    },
    mode: "inline",
    openKeys: openKeys,
    onOpenChange: function onOpenChange(openKeys) {
      setOpenKeys(openKeys);
    },
    selectedKeys: cat ? [cat] : []
  }, categories.map(function (topLevel) {
    if ((topLevel.items || []).length > 0) {
      return react_1.default.createElement(antd_1.Menu.SubMenu, {
        key: topLevel.name + "-sub",
        title: topLevel.display
      }, react_1.default.createElement(antd_1.Menu.Item, {
        key: topLevel.name,
        onClick: onMenuClick(topLevel)
      }, "\u6240\u6709", topLevel.display), (topLevel.items || []).map(function (secondLevel) {
        if ((secondLevel.items || []).length > 0) {
          return react_1.default.createElement(antd_1.Menu.SubMenu, {
            key: secondLevel.name + "-sub",
            title: secondLevel.display
          }, react_1.default.createElement(antd_1.Menu.Item, {
            key: secondLevel.name,
            onClick: onMenuClick(secondLevel)
          }, "\u6240\u6709", secondLevel.display), (secondLevel.items || []).map(function (thirdLevel) {
            return react_1.default.createElement(antd_1.Menu.Item, {
              key: thirdLevel.name,
              onClick: onMenuClick(thirdLevel)
            }, thirdLevel.display);
          }));
        }
        return react_1.default.createElement(antd_1.Menu.Item, {
          key: secondLevel.name,
          onClick: onMenuClick(secondLevel)
        }, secondLevel.display);
      }));
    }
    return react_1.default.createElement(antd_1.Menu.Item, {
      key: topLevel.name,
      onClick: onMenuClick(topLevel)
    }, topLevel.display);
  }));
}
exports.default = FilterMenu;